export default {"src":"/pro/_next/static/media/meth.9c91e38d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};